export default __webpack_public_path__ + "static/sidharth-8edd83a77b8fd5799c74f09a4e3a14a8.png";